<template>
  <div style="
            background-color: #fff;
            padding-top: 12px;
          ">
    <div id="tabActivity" class="margin-subpages" style="margin-top: 0">
      <div class="flex-row-between mt-24">
        <el-select
          v-model="selectedScopeKey"
          filterable
          placeholder="Select"
          class="input-style"
          :class="[blurMode ? 'blurelement' : '']"
          @change="handleScopeChange"
        >
          <el-option
            class="text-dropdown"
            v-for="item in teamAndcohort"
            :key="item.key"
            :label="item.name"
            :value="item.key"
            :class="[blurMode ? 'blurelement' : '']"
          ></el-option>
        </el-select>

        <div style="width: 200px">
          <el-menu
            id="menuActivityPeriod"
            class="el-menu-demo menuOptionPowerup"
            mode="horizontal"
          >
            <el-submenu index="1">
              <template slot="title">
                <span class="txtOptionShowing">{{ time }}</span>
              </template>
              <el-menu-item
                v-for="item in timeOption"
                :key="item.key"
                index="1"
                @click="changtime(item.key)"
              ><span class="menu-list-item">{{ item.name }}</span></el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div v-if="time === 'Custom Range'" class="mt-8">
        <el-date-picker
          v-model="customDateRange"
          type="daterange"
          align="left"
          start-placeholder="Start Date"
          end-placeholder="End Date"
          format="MMM d, yyyy"
          value-format="yyyy-MM-dd"
          :picker-options="datePickerOptions"
          @change="onCustomDateChange"
          size="small"
          style="width: 280px;"
        >
        </el-date-picker>
      </div>
      <div class="activity-metrics-card mt-24 mb-24">
        <div class="activity-metrics-grid">

          <div class="activity-metric">
            <div class="activity-metric-label">{{ $t("powerUp.activity.total_recognition") }}</div>
            <div v-if="metricsLoading && !hasMetricData" class="text-skeleton"></div>
            <div v-else class="activity-metric-value-row" :class="{ 'metric-loading': metricsLoading }">
              <div class="activity-metric-number">{{ dataOverAll.totalRecognition.toLocaleString() }}</div>
              <div class="activity-metric-change" :style="`color:${parseInt(dataOverAll.compareRecognition)>0?'#1AC362':parseInt(dataOverAll.compareRecognition)==0?'#777777':'#F44336'}`">{{ parseInt(dataOverAll.compareRecognition)>0? '+' + dataOverAll.compareRecognition:dataOverAll.compareRecognition }}%</div>
              <div class="activity-metric-sparkline">
                <canvas height="20px" width="52px" ref="totalrecognitionLinechart"></canvas>
              </div>
            </div>
          </div>

          <div class="activity-metric">
            <div class="activity-metric-label">{{ $t("powerUp.activity.value_aligned") }}</div>
            <div v-if="metricsLoading && !hasMetricData" class="text-skeleton"></div>
            <div v-else class="activity-metric-value-row" :class="{ 'metric-loading': metricsLoading }">
              <div class="activity-metric-number">{{ dataOverAll.value_aligned.toLocaleString() }}</div>
              <div class="activity-metric-change" :style="`color:${parseInt(dataOverAll.comparevalue_aligned)>0?'#1AC362':parseInt(dataOverAll.comparevalue_aligned)==0?'#777777':'#F44336'}`">{{parseInt(dataOverAll.comparevalue_aligned)>0? '+' + dataOverAll.comparevalue_aligned : dataOverAll.comparevalue_aligned}}%</div>
              <div class="activity-metric-sparkline">
                <canvas height="20px" width="52px" ref="valuealignedLinechart"></canvas>
              </div>
            </div>
          </div>

          <div class="activity-metric">
            <div class="activity-metric-label">{{ $t("powerUp.activity.pct_value_aligned") }}</div>
            <div v-if="metricsLoading && !hasMetricData" class="text-skeleton"></div>
            <div v-else class="activity-metric-value-row" :class="{ 'metric-loading': metricsLoading }">
              <div class="activity-metric-number">{{dataOverAll.percent_value_aligned}}%</div>
              <div class="activity-metric-change" :style="`color:${parseInt(dataOverAll.comparepercent_value_aligned)>0?'#1AC362':parseInt(dataOverAll.comparepercent_value_aligned)==0?'#777777':'#F44336'}`">{{parseInt(dataOverAll.comparepercent_value_aligned)>0? '+' + dataOverAll.comparepercent_value_aligned:dataOverAll.comparepercent_value_aligned }}%</div>
              <div class="activity-metric-sparkline">
                <canvas height="20px" width="52px" ref="percentvalueLinechart"></canvas>
              </div>
            </div>
          </div>

          <div class="activity-metric">
            <div class="activity-metric-label">{{ $t("powerUp.activity.participation_rate") }}</div>
            <div v-if="metricsLoading && !hasMetricData" class="text-skeleton"></div>
            <div v-else class="activity-metric-value-row" :class="{ 'metric-loading': metricsLoading }">
              <div class="activity-metric-number">{{dataOverAll.participation}}%</div>
              <div class="activity-metric-change" :style="`color:${parseInt(dataOverAll.past_participation)>0?'#1AC362':parseInt(dataOverAll.past_participation)==0?'#777777':'#F44336'}`">{{parseInt(dataOverAll.past_participation)>0? '+' + dataOverAll.past_participation:dataOverAll.past_participation}}%</div>
              <div class="activity-metric-sparkline">
                <canvas height="20px" width="52px" ref="participationLinechart"></canvas>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="flex-center" style="justify-content: space-between;">
        <div>
          <div class="fs-15 fw-700 pt-270">{{ $t("powerUp.activity.recognition_trends") }}</div>
          <div class="fs-12 fc-909399 mt-4">{{ $t("powerUp.activity.last_12_months") }}</div>
        </div>
        <div class="chart-table-icon cursor-pointer" @click.prevent="dialogTableView = true" title="View data in table format">
          <i class="el-icon-s-grid"></i>
        </div>
      </div>





      <div class="split-chart">
        <div class="recognition-container">
          <div class="flex-center ml-52 pl-20">
            
            <div class="recognition-title total ml-70 mr-6 mb-2"></div>
            <div class="fs-12 fw-700 opa-06 mr-12">{{ $t("powerUp.activity.total") }}</div>
            <div class="recognition-title paticipation ml-10 mr-6 mb-2"></div>
            <div class="fs-12 fw-700 opa-06 mr-12">{{ $t("powerUp.activity.values_aligned_hash") }}</div>
            <div class="recognition-title line ml-10 mr-6"></div>
            <div class="fs-12 fw-700 opa-06 mr-30">
              {{ $t("powerUp.activity.participation_rate") }}
            </div>
          </div>
          <div class="relative">
            <div v-if="!chartLoading" class="month-contariner">
              <div class="flex-center month-label fs-10 ml-38 mr-4">
                <span
                  v-for="item in trendAxisLabels"
                  :key="item.key"
                  :class="`m-auto ${isMonthZoomed && item.rawLabel === selectedMonth ? 'select' : ''}`"
                  @click.prevent="item.axisLabel && selectNewMonth(item)"
                >
                  {{ item.axisLabel }}
                </span>
              </div>
            </div>
          </div>
          
          <div class="relative">
            <div v-if="chartLoading" class="absolute-mid">
              <loading-even></loading-even>
            </div>
            <div style="height: 230px">
              <canvas ref="recognitionBarChart"></canvas>
            </div>
          </div>
        </div>
        <div class="flex-column" style="margin-left: -40px; justify-content: center;">
          <div class="heatmap-header">
            <div class="flex-row" style="align-items: center;">
              <div class="fs-12 fw-700">{{ $t("powerUp.activity.values_heatmap") }}</div>
              <span v-if="heatmapContextLabel" class="zoom-indicator">({{ heatmapContextLabel }})</span>
            </div>
            <div 
              v-if="isMonthZoomed" 
              class="reset-zoom-btn"
              @click="resetHeatmapZoom"
            >
              ← {{ $t("powerUp.activity.show_all") }}
            </div>
          </div>

          <div  v-if="!chartLoading" class="flex-row mt-12">
            <div   style="min-height: 160px;">
              <div
              class="block"
              v-for="(value, index) in displayHeatmapRows"
              :key="`value_${index}`"
              :style="`${normalizedArray(value.value)}`"
      
              ><div style="width: 42px;height: 24px;justify-content:center" class="flex-center">{{ value?value.value:'' }}</div>              
            </div>
            </div>
       
            <div class="values-text-container">
              <el-tooltip 
                v-for="(value1, index) in displayHeatmapRows"
                :key="`hashtag_${index}`"
                effect="dark" 
                placement="right"
                :content="formatHashtagToSentence(value1 ? value1.hashtag : '')"
                :disabled="!shouldShowTooltip(formatHashtagToSentence(value1 ? value1.hashtag : ''))"
              >
                <div class="ml-12 fs-12 value-text value-label"
                >
                  {{ truncateText(value1 ? value1.hashtag : '') }}
                </div>
              </el-tooltip>
            </div>
           

          </div>
          

          
            
        </div>
        <!-- <div class="radar-container relative">
          <div v-if="chartLoading" class="absolute-mid">
            <loading-even></loading-even>
          </div>
          <div style="height: 270px;" class="relative">
            <canvas ref="radarBarChart"></canvas>
            <div v-if="enabledChartValue" class="absolute-mid mt-8">
              <img src="@/assets/images/powerups/radar-chart-empty.png" />
            </div>
            <div @click="$router.push({ name: 'settings', hash: '#recognition-values' })" v-if="enabledChartValue"
              class="absolute-mid btn-add flex-mid btn-export cursor-pointer" style="width: 180px; margin-top: 54px">
              SET UP YOUR #VALUES
            </div>
          </div>
        </div> -->
      </div>

      <div class="activity-toolbar mt-20">
        <div style="width: 280px">
          <el-menu id="menuSortMonth" class="el-menu-demo menuOptionPowerup" mode="horizontal">
            <el-submenu index="1">
              <template slot="title">
                <span class="txtOptionShowing">{{ tableMonthLabel }}</span>
              </template>
              <el-menu-item v-bind:key="item.id" v-for="item in selectOpt" index="1" @click="sortBy(item)">{{ item.name
              }}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <div v-if="isTableMonthOverride" class="override-reset-pill cursor-pointer" @click="resetTableOverride">
          {{ $t("powerUp.activity.use") }} {{ time }} {{ $t("powerUp.activity.window") }}
        </div>
        <el-input
          class="search-input-activity"
          :placeholder="$t('global.Search')"
          @input="searchActivity"
          v-model="inputSearch"
          clearable
        ></el-input>
        <!-- <div class="ml-auto">
          <span v-if="arrDataCheck.length > 0" class="filter-text">
            {{
              arrDataCheck.length == 1
                ? arrDataCheck[0]
                : talentTypeOption.length == arrDataCheck.length
                ? "All Types"
                : "Multiple Selection"
            }}
          </span>
          <span v-else class="filter-text">{{ $t("powerUp.No_Filter") }}</span>
        </div> -->
        <div class="flex-center drop-down-container" :class="`${arrDataCheck.length > 0 ? 'active' : ''}`">
          <el-dropdown trigger="click" :hide-on-click="false" ref="dropdownValuesMenu">
            <!-- <img
              class="cursor-pointer"
              :src="$utils('icons', 'filter-list-24px')"
              alt="icons_filter-list-24px"
            /> -->
            <div class="text-drop-down flex-mid">
              <span v-if="arrDataCheck.length > 0">
                ({{ arrDataCheck.length }})&nbsp;
              </span>
              <div>{{ $t("powerUp.activity.values") }}</div>
              <div class="arrow ml-8">
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <div class="dropdownHeader">
                <div>
                  <el-button @click="handleSelectAllValues" class="dropdownHeaderTextStyle" type="text">{{
                    $t("powerUp.Select_all") }}</el-button>
                  <el-button @click="checkedTalentType = []" class="dropdownHeaderTextStyle" style="margin-left: 24px"
                    type="text">{{ $t("powerUp.Clear") }}</el-button>
                </div>
                <el-tooltip effect="dark" placement="top">
                  <div class="tooltipStyle" slot="content">
                    Filter by the recognition value tagged in the recognition activity
                  </div>
                  <div class="flex-center">
                    <img :src="$utils('icons', 'ic_help_outline-16px')" alt="icons_ic_help_outline-16px" />
                  </div>
                </el-tooltip>
              </div>
              <div class="dropdownItem-tabActivity thin-scrollbar">
                <el-checkbox-group v-model="checkedTalentType">
                  <el-dropdown-item v-for="item in talentTypeOption" :key="item.type">
                    <el-checkbox :label="item.type" :key="item.type">{{
                      item.type
                    }}</el-checkbox>
                  </el-dropdown-item>
                </el-checkbox-group>
              </div>
              <div class="dropdownFooter">
                <el-button @click="clearValueSelected" type="cancel">{{
                  $t("powerUp.Cancel")
                }}</el-button>
                <el-button @click="saveValueFiltered" type="save">{{
                  $t("powerUp.Okay")
                }}</el-button>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-if="arrDataCheck.length > 0" class="relative" style="width: 26px">
            <div @click="checkedTalentType = [], saveValueFiltered()" class="drop-down-close">
              <div class="x-btn">
              </div>
            </div>
          </div>
        </div>
        <div class="flex-center drop-down-container" :class="`${arrRewardTypeCheck.length > 0 ? 'active' : ''}`">
          <el-dropdown trigger="click" :hide-on-click="false" ref="dropdownRewardTypeMenu">
            <div class="text-drop-down flex-mid">
              <span v-if="arrRewardTypeCheck.length > 0">
                ({{ arrRewardTypeCheck.length }})&nbsp;
              </span>
              <div>{{ $t("powerUp.Reward_Type") }}</div>
              <div class="arrow ml-8">
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <div class="dropdownHeader">
                <div>
                  <el-button @click="handleSelectAllRewardType" class="dropdownHeaderTextStyle" type="text">{{
                    $t("powerUp.Select_all") }}</el-button>
                  <el-button @click="checkedArrRewardTypeCheck = []" class="dropdownHeaderTextStyle" style="margin-left: 24px"
                    type="text">{{ $t("powerUp.Clear") }}</el-button>
                </div>
                <el-tooltip effect="dark" placement="top">
                  <div class="tooltipStyle" slot="content">
                    Filter by the type of recognition between coins, gems, and medals
                  </div>
                  <div class="flex-center">
                    <img :src="$utils('icons', 'ic_help_outline-16px')" alt="icons_ic_help_outline-16px" />
                  </div>
                </el-tooltip>
              </div>
              <div class="dropdownItem-tabActivity thin-scrollbar">
                <el-checkbox-group v-model="checkedArrRewardTypeCheck">
                  <el-dropdown-item v-for="item in rewardTypeOptions" :key="item.type">
                    <el-checkbox :label="item.type" :key="item.type">{{
                      item.type
                    }}</el-checkbox>
                  </el-dropdown-item>
                </el-checkbox-group>
              </div>
              <div class="dropdownFooter">
                <el-button @click="clearRewardTypeSelected" type="cancel">{{
                  $t("powerUp.Cancel")
                }}</el-button>
                <el-button @click="saveRewardTypeFiltered" type="save">{{
                  $t("powerUp.Okay")
                }}</el-button>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-if="arrRewardTypeCheck.length > 0" class="relative" style="width: 26px">
            <div @click="checkedArrRewardTypeCheck = [], saveRewardTypeFiltered()" class="drop-down-close">
              <div class="x-btn">
              </div>
            </div>
          </div>
        </div>
        <div
          class="toolbar-icon-btn toolbar-icon-btn--end flex-mid cursor-pointer"
          @click="dialogExport = true"
          title="Export"
        >
          <happily-icon name="download" :size="18" />
        </div>
      </div>
    
      <div class="line-page mt-24 mb-12"></div>
      <div class="activity-table-shell" :class="{ 'is-loading': activityTableLoading }">
        <div v-if="activityTableLoading" class="activity-table-overlay">
          <loading-even></loading-even>
        </div>
        <el-table :data="outbox" style="width: 100%" class="more-option-hover" @sort-change="sortChange" :default-sort="{prop: 'date', order: 'descending'}" :empty-text="
          $utils('placeholderInTable', {
            loadingLoop: tableLoadingLoop,
            table: outbox.length,
            textLoading: ' ',
            textEmpty: 'There is no activity data available for this period',
            textNotFound: ' ',
          })
        ">
          <el-table-column :label="$t('powerUp.Recipient')"  prop="send_to" sortable  width="140">
            <template slot-scope="scope">
              <span class="fs-14 fw-500 fc-4A4A4A"
              :class="[ blurMode ?  'blurelement': '' ]">{{
                scope.row.send_to
              }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('powerUp.From')" width="140" prop="from" sortable>
            <template slot-scope="scope">
              <div class="fs-14 fw-500 fc-4A4A4A"
              :class="[ blurMode ?  'blurelement': '' ]">{{ checkChampion(scope.row) }}</div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('powerUp.For')">
            <template slot-scope="scope">
              <div class="fs-14 fw-400 fc-4A4A4A" :style="$utils('fontStyle', scope.row.reason) + ';'">
                <span>
                  {{ scope.row.reason }} 
                </span>
                <span class="font-lato" style="color: #00bcd4">
                  {{
                    `${scope.row.hashtag ? scope.row.hashtag.join(" ") : ""}`
                  }}
                  
                </span>
                <span v-if="scope.row.champion_note" class="font-lato">{{ scope.row.champion_note? `. (Endorsement Note: ${scope.row.champion_note})` :"" }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('powerUp.Reward')" width="100" prop="rewardSorting" sortable>
            <template slot-scope="scope">
              <div v-if="scope.row.medal" class="fw-700">
                <span class="fs-14 fc-4A4A4A">🏅{{ scope.row.reward }}</span>
              </div>
              <div v-else class="fw-700">
                <span class="fs-14 fc-4A4A4A">+{{
                  $utils("addCommasInNumber", checkPoint(scope.row))
                }}&nbsp;</span>
                <span class="fs-14 fc-4A4A4A">{{ scope.row.unit }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('powerUp.Sent_on')" header-align="right" align="right" width="190" prop="date" sortable>
            <template slot-scope="scope">
              <span v-if="checkDate(scope.row)" class="fs-14 fw-400 fc-4A4A4A">({{ scope.row.send_on }})</span>
              <span v-else class="fs-14 fw-400 fc-4A4A4A">{{
                scope.row.send_on
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex-center pagination mt-14">
        <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="10" :pager-count="5"
          layout="prev, pager, next" :total="results"></el-pagination>
        <span class="results-status">
          {{ outbox.length }} {{ $t("powerUp.results_from") }}
          {{ $utils("addCommasInNumber", results) }} {{ $t("powerUp.results") }}
        </span>
      </div>
    </div>
    <el-dialog :visible.sync="dialogExport" width="530px">
      <div class="mx-12">
        <div class="fs-20 fw-700 fc-000000" style="margin-top: -26px">
          {{ $t("powerUp.Export_Power_up_Activity") }}
        </div>
        <div class="mt-32 mb-12 fc-4A4A4A fs-16 fw-700">
          {{ $t("powerUp.Date_Range") }}
        </div>
        <div class="center">
          <el-date-picker v-model="exportDate" type="daterange" align="center" start-placeholder="Start Date"
            end-placeholder="End Date" range-separator="To" :default-time="['12:00:00', '08:00:00']" style="width: 100%">
          </el-date-picker>
        </div>
        <div class="flex mt-40">
          <div class="btn-gray flex-mid btn-export cursor-pointer ml-auto" @click.prevent="dialogExport = false">
            <div class="">{{ $t("powerUp.Cancel") }}</div>
          </div>
          <div class="btn-add flex-mid btn-export cursor-pointer ml-16" @click="exportTableToCSV">
            <happily-icon name="download" :size="16" />
            <div class="ml-12">{{ $t("powerUp.EXPORT") }}</div>
            <download-progress :active="exportActivityStatus"></download-progress>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogTableView" width="800px" class="table-view-dialog">
      <div class="mx-20">
        <div class="fs-20 fw-700 fc-000000" style="margin-top: -20px; margin-bottom: 20px;">
          {{ $t("powerUp.activity.recognition_trends_data") }}
          <span class="fs-12 fw-400 fc-909399 ml-8">{{ $t("powerUp.activity.last_12_months") }}</span>
        </div>
        <div>
          <el-table :data="chartTableData" style="width: 100%" class="chart-table">
            <el-table-column :label="$t('powerUp.activity.month')" prop="month" width="130" sortable>
              <template slot-scope="scope">
                <span class="fs-14 fw-600 fc-4A4A4A">{{ scope.row.month }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('powerUp.activity.total_recognition')" prop="totalRecognition" width="170" sortable align="right">
              <template slot-scope="scope">
                <div class="number-cell">
                  <div class="recognition-value">
                    <div v-if="scope.row.isProjected" class="dual-value">
                      <span class="fs-14 fw-500 fc-4A4A4A">{{ $utils("addCommasInNumber", scope.row.originalTotal) }}</span>
                      <span class="fs-12 fw-400 fc-909399">→ {{ $utils("addCommasInNumber", scope.row.totalRecognition) }}*</span>
                    </div>
                    <span v-else class="fs-14 fw-500 fc-4A4A4A">{{ $utils("addCommasInNumber", scope.row.totalRecognition) }}</span>
                  </div>
                  <div class="trend-indicator">
                    <i 
                      :class="getTrendIcon(scope.row, scope.$index)" 
                      :style="{ color: getTrendColor(scope.row, scope.$index) }"
                    ></i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('powerUp.activity.values_aligned')" prop="valuesAligned" width="160" sortable align="right">
              <template slot-scope="scope">
                <div class="values-cell">
                  <div class="values-main">
                    <div v-if="scope.row.isProjected" class="dual-value">
                      <span class="fs-14 fw-500 fc-4A4A4A">{{ $utils("addCommasInNumber", scope.row.originalValues) }}</span>
                      <span class="fs-12 fw-400 fc-909399">→ {{ $utils("addCommasInNumber", scope.row.valuesAligned) }}*</span>
                    </div>
                    <span v-else class="fs-14 fw-500 fc-4A4A4A">{{ $utils("addCommasInNumber", scope.row.valuesAligned) }}</span>
                  </div>
                  <span class="percentage-label">({{ Math.round(scope.row.percentValuesAligned) }}%)</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('powerUp.activity.pct_values_aligned')" prop="percentValuesAligned" width="110" sortable align="center">
              <template slot-scope="scope">
                <span class="fs-14 fw-600" :class="getPercentageClass(scope.row.percentValuesAligned)">
                  {{ Math.round(scope.row.percentValuesAligned) }}%
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('powerUp.activity.participation_rate')" prop="participationRate" width="110" sortable align="center">
              <template slot-scope="scope">
                <span class="fs-14 fw-600" :class="getPercentageClass(scope.row.participationRate)">
                  {{ Math.round(scope.row.participationRate) }}%
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="flex mt-32 mb-8">
          <div class="btn-gray flex-mid btn-export cursor-pointer ml-auto mr-16" @click="exportTableData">
            <happily-icon name="download" :size="16" />
            <div class="ml-12">{{ $t("powerUp.activity.export_csv") }}</div>
          </div>
          <div class="btn-add flex-mid btn-export cursor-pointer" @click.prevent="dialogTableView = false">
            <div class="">{{ $t("global.Close") }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import format from "date-fns/format";
import endOfMonth from "date-fns/end_of_month";
import subMonths from "date-fns/sub_months";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "outbox",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  data() {
    return {
      current_page: 1,
      activityTableLoading: false,
      tableHasLoadedOnce: false,
      selectedScopeKey: "",
      isTableMonthOverride: false,
      selectedOpt: format(new Date(), "MMMM YYYY"), //"May 2021",
      selectedOptValue: format(new Date(), "YYYY-MM"), //"2021-06",
      // selectOpt: [
      //   { name: "May 2021", id: "may2021"},
      //   { name: "June 2021", id: "june2021"},
      //   { name: "August 2021", id: "august2021"},
      // ],
      dialogExport: false,
      dialogTableView: false,
      exportDate: [
        format(new Date(), "YYYY-MM-01 HH:mm:ss"),
        format(new Date(), "YYYY-MM-DD HH:mm:ss"),
      ],
      exportActivityStatus: false,
      // talentTypeOption: [
      //   { type: "#a" },
      //   { type: "#b" },
      // ],
      checkedTalentType: [],
      arrDataCheck: [],
      selectedMonth: "",
      myBarChart: "",
      myRadarChart: "",

    
      real_time_chart_percent_valuealigned: "",
      real_time_chart_participation: "",
      enabledChartValue: false,
      // rewardTypeOptions: [
      // { type: "+3 coins" },
      // { type: "+5 coins" },
      // ],
      checkedArrRewardTypeCheck: [],
      arrRewardTypeCheck: [],
      classificationOptions: [
      { type: "Super Recognition" },
      ],
      checkedArrClassificationCheck: [],
      arrClassificationCheck: [],
      time: "Past 30 days",
      timeOption:[{key:"Past 30 days",name:"Past 30 days"},
      {key:"Past 90 days",name:"Past 90 days"},
      {key:"Past 180 days",name:"Past 180 days"},
      {key:"Past year",name:"Past year"},
      {key:'This Quarter',name:"This Quarter"},
      {key:'Last Quarter',name:"Last Quarter"},
      {key:'Custom Range',name:"Custom Range"}],
      customDateRange: null,
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        },
        shortcuts: [{
          text: 'Last 30 days',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last 90 days',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last year',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Year 2024',
          onClick(picker) {
            const start = new Date('2024-01-01');
            const end = new Date('2024-12-31');
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Year 2025',
          onClick(picker) {
            const start = new Date('2025-01-01');
            const end = new Date('2025-12-31');
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      isMonthZoomed: false,
      // dataArray: [50, 40, 20, 10],
      // hashtag: ["#Courage-to-fail", "#Initiative-making","#Responsiveness","#Excellence"],
      inputSearch: "",
      searchTimeout: null,
      
    };
  },
  async created() {
    this.selectedScopeKey = this.getDefaultScopeKey();
    // Load hashtags/values for the Values filter
    this.$store.dispatch("powerups/getHashtag");

    await this.loadScopeDependencies();
    this.$store.dispatch("activity/getList_month", this.user);
    this.$store.commit("authen/setActiveIndex", "2");
    await this.reloadScopedData({ resetTableOverride: true });
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    isLeadershipUser() {
      return this.user && this.user.user_type === "leadership";
    },
    outbox() {
      return this.$store.getters["activity/activity"];
    },
    outboxall() {
      return this.$store.getters["activity/activityall"];
    },
    durationActivityall() {
      return this.$store.getters["activity/durationActivityall"] || [];
    },
    page() {
      return this.$store.getters["activity/page"];
    },
    results() {
      return this.$store.getters["activity/results"];
    },
    selectOpt() {
      return this.$store.getters["activity/list_month"];
    },
    reportActivity() {
      return this.$store.getters["activity/reportActivity"];
    },
    talentTypeOption() {
      return this.$store.getters["powerups/talentTypeOption"];
    },
    datachart() {
      return this.$store.getters["activity/barchart"];
    },
    radarchart() {
      return this.$store.getters["activity/radarchart"];
    },
    displayHeatmapRows() {
      if (this.isMonthZoomed) {
        const zoomedRows = this.radarchart && Array.isArray(this.radarchart.radarchart)
          ? this.radarchart.radarchart
          : [];
        return zoomedRows.slice().sort((a, b) => Number(b.value || 0) - Number(a.value || 0));
      }

      const aggregated = {};
      const knownLabels = this.radarchart && Array.isArray(this.radarchart.label)
        ? this.radarchart.label
        : [];

      knownLabels.forEach((label) => {
        const normalizedLabel = this.normalizeHeatmapTag(label);
        if (normalizedLabel && aggregated[normalizedLabel] === undefined) {
          aggregated[normalizedLabel] = 0;
        }
      });

      const sourceRows = this.durationActivityall.length > 0 ? this.durationActivityall : this.outboxall;

      (sourceRows || []).forEach((record) => {
        const uniqueTags = Array.from(
          new Set(
            (Array.isArray(record && record.hashtag) ? record.hashtag : [])
              .map((tag) => this.normalizeHeatmapTag(tag))
              .filter(Boolean)
          )
        );

        uniqueTags.forEach((tag) => {
          if (aggregated[tag] === undefined) {
            aggregated[tag] = 0;
          }
          aggregated[tag] += 1;
        });
      });

      return Object.entries(aggregated)
        .map(([hashtag, value]) => ({
          hashtag,
          value: Number(value || 0),
        }))
        .sort((a, b) => b.value - a.value);
    },
    heatmapMax() {
      const values = this.displayHeatmapRows.map((item) => Number(item.value || 0));
      return values.length ? Math.max(...values) : 1;
    },
    chartLoading() {
      return this.$store.getters["activity/chartLoading"];
    },
    metricsLoading() {
      return this.$store.getters["activity/metricsLoading"];
    },
    listChartmonth() {
      return this.$store.getters["activity/listChartmonth"];
    },
    rewardTypeOptions(){
      return this.$store.getters["activity/rewardTypeOptions"];
    },
    dataOverAll(){
      return this.$store.getters["activity/dataOverAll"];
    },
    hasMetricData() {
      return !!(
        this.dataOverAll &&
        Array.isArray(this.dataOverAll.labels) &&
        this.dataOverAll.labels.length > 0
      );
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    teamAndcohort() {
      const options = this.$store.getters["leaderboards/teamAndcohort"] || [];
      if (!this.isLeadershipUser) {
        return options;
      }
      const scopedOptions = options.filter((item) => item && item.key !== "All Teams and Cohorts");
      if (this.user && this.user.team && !scopedOptions.some((item) => item.key === this.user.team)) {
        const allTeam = this.$store.getters["main/allTeam"] || {};
        scopedOptions.unshift({
          key: this.user.team,
          name: allTeam[this.user.team] ? allTeam[this.user.team].name : "My Team",
        });
      }
      return scopedOptions;
    },
    tableLoadingLoop() {
      if (this.activityTableLoading || !this.tableHasLoadedOnce) {
        return 0;
      }
      return 1;
    },
    tableMonthLabel() {
      if (this.isTableMonthOverride) {
        return `${this.selectedOpt} (month override)`;
      }
      if (this.time === "Custom Range" && this.customDateRange && this.customDateRange.length === 2) {
        return `${this.customDateRange[0]} to ${this.customDateRange[1]}`;
      }
      return `${this.time} (period)`;
    },
    recognitionTrendBuckets() {
      const totals = this.datachart && Array.isArray(this.datachart.barchart) ? this.datachart.barchart : [];
      const valuesAlignedSeries = this.datachart && Array.isArray(this.datachart.hashtagBarchart) ? this.datachart.hashtagBarchart : [];
      const participationSeries = this.datachart && Array.isArray(this.datachart.participation) ? this.datachart.participation : [];

      return totals.map((value, index) => {
        const monthDate = subMonths(new Date(), Math.max(totals.length - index - 1, 0));
        const monthKey = format(monthDate, "YYYY-MM");
        const totalRecognition = Number(value || 0);
        const valuesAligned = Number(valuesAlignedSeries[index] || 0);
        const participationRate = Number(participationSeries[index] || 0);
        const percentValuesAligned = totalRecognition > 0 ? (valuesAligned / totalRecognition) * 100 : 0;

        return {
          key: `${monthKey}-${index}`,
          rawLabel: monthKey,
          axisLabel: format(monthDate, "MMM").toUpperCase(),
          tooltipLabel: format(monthDate, "MMM YYYY"),
          heatmapKey: monthKey,
          unit: "month",
          totalRecognition,
          valuesAligned,
          participationRate,
          percentValuesAligned,
          sortValue: parseInt(monthKey.replace("-", ""), 10),
        };
      });
    },
    trendAxisLabels() {
      const totalBuckets = this.recognitionTrendBuckets.length;
      return this.recognitionTrendBuckets.map((bucket, index) => ({
        ...bucket,
        axisLabel: this.shouldShowTrendAxisLabel(index, totalBuckets) ? bucket.axisLabel : "",
      }));
    },
    selectedHeatmapLabel() {
      const selectedBucket = this.recognitionTrendBuckets.find((bucket) => bucket.rawLabel === this.selectedMonth);
      if (selectedBucket && selectedBucket.heatmapKey) {
        return this.getTrendLabelMeta(selectedBucket.heatmapKey).tooltipLabel;
      }
      return this.selectedMonth;
    },
    heatmapContextLabel() {
      if (this.isMonthZoomed) {
        return this.selectedHeatmapLabel;
      }
      if (this.time === "Custom Range" && this.customDateRange && this.customDateRange.length === 2) {
        return `${this.customDateRange[0]} to ${this.customDateRange[1]}`;
      }
      return this.time;
    },
    chartTableData() {
      return this.recognitionTrendBuckets.map((bucket) => {
        const isProjected = bucket.unit === "month" && this.isCurrentMonth(bucket.heatmapKey);
        let projectedTotalRecognition = bucket.totalRecognition;
        let projectedValuesAligned = bucket.valuesAligned;

        if (isProjected) {
          const projectionData = this.calculateProjectedValues(bucket.totalRecognition, bucket.valuesAligned, bucket.heatmapKey);
          projectedTotalRecognition = projectionData.projectedTotal;
          projectedValuesAligned = projectionData.projectedValues;
        }

        return {
          month: bucket.tooltipLabel || bucket.rawLabel || "",
          monthSort: bucket.sortValue,
          totalRecognition: projectedTotalRecognition,
          valuesAligned: projectedValuesAligned,
          percentValuesAligned: projectedTotalRecognition > 0 ? (projectedValuesAligned / projectedTotalRecognition) * 100 : 0,
          participationRate: bucket.participationRate,
          isProjected,
          originalTotal: bucket.totalRecognition,
          originalValues: bucket.valuesAligned,
        };
      }).sort((a, b) => b.monthSort - a.monthSort);
    },
  },
  watch: {
    datachart() {
      if (this.myBarChart) {
        this.myBarChart.destroy();
      }
    },

    dataOverAll(){
      if (!this.metricsLoading) {
        this.$nextTick(() => {
          this.rerenderMetricLineCharts();
        });
      }
    },
    metricsLoading(isLoading) {
      if (isLoading) {
        return;
      }

      this.$nextTick(() => {
        this.rerenderMetricLineCharts();
      });
    },
    outboxall: {
      handler(newVal, oldVal) {
        // When data loads, apply default sort by date descending
        // Only sort if:
        // 1. Data exists and is an array with items
        // 2. No active search
        // 3. Not already filtered (filter flag is false)
        // 4. This is initial load (oldVal is empty/different length)
        const isInitialLoad = !oldVal || oldVal.length === 0 || oldVal.length !== newVal.length;
        const filterActive = this.$store.getters["activity/filter"];
        
        if (newVal && Array.isArray(newVal) && newVal.length > 0 && 
            !this.inputSearch && !filterActive && isInitialLoad) {
          this.$nextTick(() => {
            // Double-check that sortData action exists before dispatching
            if (this.$store && this.$store.dispatch) {
              this.$store.dispatch("activity/sortData", {
                column: 'date',
                order: 'descending',
              });
            }
          });
        }
      },
      immediate: false
    },
    teamAndcohort: {
      handler(newVal) {
        if (!newVal || newVal.length === 0) {
          return;
        }
        if (!this.selectedScopeKey) {
          this.selectedScopeKey = this.getDefaultScopeKey();
        }
      },
      immediate: true
    }

  },
  mounted() {
    //this.randerRecognitionChart();
    //this.randerRadarChart();
    // this.randerLineChart()
    // this.randervaluealignedLineChart()
    // this.randerpercentvalueLineChart()
    // this.randerparticipationLineChart()
  },
  methods: {
    getDefaultScopeKey() {
      return this.isLeadershipUser && this.user.team ? this.user.team : "All Teams and Cohorts";
    },
    getResolvedScopeKey() {
      if (this.isLeadershipUser && this.user.team) {
        return this.user.team;
      }
      return this.selectedScopeKey || "All Teams and Cohorts";
    },
    async loadScopeDependencies() {
      await Promise.all([
        this.$store.dispatch("main/getuser", false),
        this.$store.dispatch("main/getOrganization"),
      ]);
      this.$store.dispatch("leaderboards/getteamAndcohort", this.user);
    },
    getScopePayload() {
      return {
        company: this.user.company,
        scopeKey: this.getResolvedScopeKey(),
      };
    },
    getCurrentPeriodRange() {
      if (this.time === "Custom Range" && this.customDateRange && this.customDateRange.length === 2) {
        return {
          startDate: this.customDateRange[0],
          endDate: this.customDateRange[1],
        };
      }

      const now = new Date();
      const endDate = format(now, "YYYY-MM-DD");
      let startDate = format(new Date(now.getTime() - 29 * 24 * 60 * 60 * 1000), "YYYY-MM-DD");

      if (this.time === "Past 90 days") {
        startDate = format(new Date(now.getTime() - 89 * 24 * 60 * 60 * 1000), "YYYY-MM-DD");
      } else if (this.time === "Past 180 days") {
        startDate = format(new Date(now.getTime() - 179 * 24 * 60 * 60 * 1000), "YYYY-MM-DD");
      } else if (this.time === "Past year") {
        startDate = format(new Date(now.getTime() - 364 * 24 * 60 * 60 * 1000), "YYYY-MM-DD");
      } else if (this.time === "This Quarter") {
        const quarterStartMonth = Math.floor(now.getMonth() / 3) * 3;
        startDate = format(new Date(now.getFullYear(), quarterStartMonth, 1), "YYYY-MM-DD");
      } else if (this.time === "Last Quarter") {
        const quarterStartMonth = Math.floor(now.getMonth() / 3) * 3;
        const lastQuarterEnd = new Date(now.getFullYear(), quarterStartMonth, 0);
        const lastQuarterStart = new Date(
          lastQuarterEnd.getFullYear(),
          quarterStartMonth - 3,
          1
        );
        startDate = format(lastQuarterStart, "YYYY-MM-DD");
        return {
          startDate,
          endDate: format(lastQuarterEnd, "YYYY-MM-DD"),
        };
      }

      return { startDate, endDate };
    },
    async refreshMetricsForCurrentPeriod(options = {}) {
      const includeHeatmapRows = !!options.includeHeatmapRows;
      const { startDate, endDate } = this.getCurrentPeriodRange();
      if (!startDate || !endDate) {
        return;
      }
      await this.$store.dispatch("activity/getPeriodMetrics", {
        company: this.user.company,
        scopeKey: this.getResolvedScopeKey(),
        time: this.time,
        startDate,
        endDate,
        includeTableRows: includeHeatmapRows,
      });
    },
    async loadDurationDataForCurrentPeriod() {
      const { startDate, endDate } = this.getCurrentPeriodRange();
      if (!startDate || !endDate) {
        return;
      }
      this.exportDate = [`${startDate} 00:00:00`, `${endDate} 23:59:59`];
      this.activityTableLoading = true;
      try {
        await this.$store.dispatch("activity/loadPeriodPayload", {
          user: this.user,
          company: this.user.company,
          scopeKey: this.getResolvedScopeKey(),
          time: this.time,
          startDate,
          endDate,
        });
      } finally {
        this.activityTableLoading = false;
        this.tableHasLoadedOnce = true;
      }
    },
    rerenderMetricLineCharts() {
      if (this.totalrecognitionLinechart) {
        this.totalrecognitionLinechart.destroy();
      }
      if (this.valuealignedLinechart) {
        this.valuealignedLinechart.destroy();
      }
      if (this.percentvalueLinechart) {
        this.percentvalueLinechart.destroy();
      }
      if (this.participationLinechart) {
        this.participationLinechart.destroy();
      }
      this.randerLineChart();
      this.randervaluealignedLineChart();
      this.randerpercentvalueLineChart();
      this.randerparticipationLineChart();
    },
    rerenderTrendChart() {
      if (this.myBarChart) {
        this.myBarChart.destroy();
      }
      this.randerRecognitionChart();
    },
    async loadMonthlyTrend(scopePayload) {
      await this.$store.dispatch("activity/getMonthlyTrend", scopePayload);
      this.rerenderTrendChart();
      if (this.isMonthZoomed && this.selectedMonth) {
        this.$store.dispatch("activity/changeRedarChart", {
          selectedMonth: this.selectedMonth,
          label: this.radarchart.label,
        });
      }
    },
    async loadTableDataForPeriod() {
      await this.loadDurationDataForCurrentPeriod();
    },
    async loadTableDataForSelectedMonth() {
      let lastday = parseInt(format(endOfMonth(this.selectedOpt), "D"));
      let dayOfMonth = lastday + " " + this.selectedOpt;
      this.exportDate = [
        format(this.selectedOpt, "YYYY-MM-01 HH:mm:ss"),
        format(new Date(dayOfMonth), "YYYY-MM-DD HH:mm:ss"),
      ];
      this.activityTableLoading = true;
      try {
        await this.$store.dispatch("activity/getData", {
          user: this.user,
          start: this.selectedOpt,
          end: this.selectedOpt,
          value: this.selectedOptValue,
          scopeKey: this.getResolvedScopeKey(),
        });
      } finally {
        this.activityTableLoading = false;
        this.tableHasLoadedOnce = true;
      }
    },
    applyActiveTableFilters() {
      if (
        this.arrDataCheck.length > 0 ||
        this.arrRewardTypeCheck.length > 0 ||
        this.arrClassificationCheck.length > 0
      ) {
        this.$store.dispatch("activity/getdatafilter", {
          core_value: this.checkedTalentType,
          classification: this.checkedArrClassificationCheck,
          reward: this.checkedArrRewardTypeCheck,
        });
      }
      if (this.inputSearch && this.inputSearch.trim()) {
        this.searchActivity();
      }
    },
    async reloadScopedData({ resetTableOverride = false } = {}) {
      if (resetTableOverride) {
        this.isTableMonthOverride = false;
      }
      this.isMonthZoomed = false;
      this.selectedMonth = "";
      const scopePayload = this.getScopePayload();
      let durationPromise;
      if (this.isTableMonthOverride && !resetTableOverride) {
        durationPromise = Promise.all([
          this.refreshMetricsForCurrentPeriod({ includeHeatmapRows: true }),
          this.loadTableDataForSelectedMonth(),
        ]).then(() => {
          this.applyActiveTableFilters();
        });
      } else {
        durationPromise = this.loadDurationDataForCurrentPeriod().then(() => {
          this.applyActiveTableFilters();
        });
      }
      const trendPromise = this.loadMonthlyTrend(scopePayload);

      await Promise.all([durationPromise, trendPromise]);
    },
    async handleScopeChange() {
      if (this.isLeadershipUser) {
        this.selectedScopeKey = this.getDefaultScopeKey();
      }
      await this.reloadScopedData();
    },
    async resetTableOverride() {
      this.isTableMonthOverride = false;
      await this.loadTableDataForPeriod();
      this.applyActiveTableFilters();
    },
    normalizedArray(value) {  

      const max = this.heatmapMax || 1;
        
        return  `opacity: ${(value / max) * 0.8 + 0.2}`;
    },

    truncateText(text, maxLength = 30) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    shouldShowTooltip(text, maxLength = 30) {
      if (!text) return false;
      return text.length > maxLength;
    },

    formatHashtagToSentence(hashtag) {
      if (!hashtag) return '';
      
      // Remove the # symbol if present
      let text = hashtag.startsWith('#') ? hashtag.substring(1) : hashtag;
      
      // Replace hyphens with spaces
      text = text.replace(/-/g, ' ');
      
      // Convert to proper case (capitalize first letter of each word)
      text = text.replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      
      return text;
    },
    normalizeHeatmapTag(hashtag) {
      if (!hashtag) {
        return "";
      }
      return `${hashtag}`.replace(/^#/, "").trim();
    },
    getTrendLabelMeta(label) {
      const rawLabel = `${label || ""}`;
      const monthlyView = this.time === "Past year" || this.time === "Custom Range";
      const weeklyView = ["Past 90 days", "Past 180 days", "This Quarter", "Last Quarter"].includes(this.time);

      if (this.time === "Past 30 days" && /^\d{4}-\d{2}-\d{2}$/.test(rawLabel)) {
        const [year, month, day] = rawLabel.split("-").map(Number);
        const date = new Date(year, month - 1, day);
        return {
          axisLabel: format(date, "MMM D"),
          tooltipLabel: format(date, "MMM D, YYYY"),
          heatmapKey: rawLabel.slice(0, 7),
          unit: "day",
        };
      }

      if (monthlyView && /^\d{4}-\d{2}$/.test(rawLabel)) {
        const [year, month] = rawLabel.split("-").map(Number);
        const date = new Date(year, month - 1, 1);
        return {
          axisLabel: format(date, "MMM"),
          tooltipLabel: format(date, "MMM YYYY"),
          heatmapKey: rawLabel,
          unit: "month",
        };
      }

      if (weeklyView && /^\d{4}-\d{1,2}$/.test(rawLabel)) {
        const [year, week] = rawLabel.split("-");
        return {
          axisLabel: `W${week}`,
          tooltipLabel: `Week ${week}, ${year}`,
          heatmapKey: null,
          unit: "week",
        };
      }

      if (/^\d{4}-\d{2}$/.test(rawLabel)) {
        const [year, month] = rawLabel.split("-").map(Number);
        const date = new Date(year, month - 1, 1);
        return {
          axisLabel: format(date, "MMM"),
          tooltipLabel: format(date, "MMM YYYY"),
          heatmapKey: rawLabel,
          unit: "month",
        };
      }

      return {
        axisLabel: rawLabel,
        tooltipLabel: rawLabel,
        heatmapKey: null,
        unit: "label",
      };
    },
    shouldShowTrendAxisLabel(index, totalBuckets) {
      if (totalBuckets <= 12) {
        return true;
      }

      const targetLabels = totalBuckets <= 16 ? 8 : 6;
      const step = Math.ceil(totalBuckets / targetLabels);
      return index === 0 || index === totalBuckets - 1 || index % step === 0;
    },

    searchActivity() {
      // Debounce search to avoid too many re-renders
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      this.searchTimeout = setTimeout(() => {
        const pageSize = 10;
        // If search is empty, reload the original data
        if (!this.inputSearch || this.inputSearch.trim() === '') {
          this.$store.commit("activity/setPage", 1);
          
          // Check if filters are applied
          if (this.arrDataCheck.length > 0 || this.arrRewardTypeCheck.length > 0 || this.arrClassificationCheck.length > 0) {
            this.$store.dispatch("activity/getdatafilter", {
              core_value: this.checkedTalentType,
              classification: this.checkedArrClassificationCheck,
              reward: this.checkedArrRewardTypeCheck
            });
          } else {
            this.$store.commit("activity/setFilter", false);
            this.$store.commit("activity/setResults", this.outboxall.length);
            this.$store.commit("activity/setActivity", this.outboxall.slice(0, pageSize));
          }
          return;
        }
        
        // Perform search on all data
        const searchTerm = this.inputSearch.toLowerCase().trim();
        
        // Safety check: ensure outboxall exists and is an array
        if (!this.outboxall || !Array.isArray(this.outboxall)) {
          return;
        }
        
        const filtered = this.outboxall.filter(item => {
          try {
            // Search in recipient name
            const recipientMatch = item.send_to && item.send_to.toLowerCase().includes(searchTerm);
            
            // Search in from name (including champion) - with error handling
            let fromMatch = false;
            try {
              const fromName = this.checkChampion(item);
              fromMatch = fromName && fromName.toLowerCase().includes(searchTerm);
            } catch (e) {
              // Fallback to just the from field if checkChampion fails
              fromMatch = item.from && item.from.toLowerCase().includes(searchTerm);
            }
            
            // Search in reason/message
            const reasonMatch = item.reason && item.reason.toLowerCase().includes(searchTerm);
            
            // Search in hashtags
            const hashtagMatch = item.hashtag && Array.isArray(item.hashtag) && item.hashtag.some(tag => 
              tag && tag.toLowerCase().includes(searchTerm)
            );
            
            // Search in champion note
            const championNoteMatch = item.champion_note && item.champion_note.toLowerCase().includes(searchTerm);
            
            return recipientMatch || fromMatch || reasonMatch || hashtagMatch || championNoteMatch;
          } catch (error) {
            // Silently fail for individual items to prevent search from breaking
            return false;
          }
        });
        
        // Update the store with filtered results using the same pattern as getdatafilter
        this.$store.commit("activity/setResults", filtered.length);
        this.$store.commit("activity/setActivityAllfilter", filtered);
        this.$store.commit("activity/setActivity", filtered.slice(0, pageSize));
        this.$store.commit("activity/setPage", 1);
        this.$store.commit("activity/setFilter", true);
      }, 300);
    },

    async changtime(key){
      if (key) {
        this.time = key;
      }
      
      if (this.time === 'Custom Range') {
        return;
      }

      if (this.isTableMonthOverride) {
        await this.refreshMetricsForCurrentPeriod({ includeHeatmapRows: true });
      } else {
        await this.loadDurationDataForCurrentPeriod();
        this.applyActiveTableFilters();
      }
    },
    async onCustomDateChange(dateRange) {
      if (!dateRange || dateRange.length !== 2) {
        return;
      }
      
      if (this.isTableMonthOverride) {
        await this.refreshMetricsForCurrentPeriod({ includeHeatmapRows: true });
      } else {
        await this.loadDurationDataForCurrentPeriod();
        this.applyActiveTableFilters();
      }
    },
    randerLineChart() {
      var totalrecognitionLinechart = this.$refs.totalrecognitionLinechart;
      const point= []
      let color=''
      if(parseInt(this.dataOverAll.compareRecognition)>0){
          color='#1AC362'
      }else if(parseInt(this.dataOverAll.compareRecognition)==0){
        color='#777777'
      }else{
        color='#F44336'
      }
      for(var i=0;i<this.dataOverAll.labels.length;i++){
        point.push(0)
      }
     
      if (totalrecognitionLinechart) {
        const lineChartData = {
          labels:this.dataOverAll.labels,
          datasets: [
            {
              backgroundColor: "#7E3FC700",
              borderColor: color,//"#777777",
              pointHoverBackgroundColor: color,//"#777777",
              pointBackgroundColor:color,// "#777777",
              pointRadius: point,//[0, 0, 0, 0, 0],
              lineTension: 0,
              data: this.dataOverAll.chartRecognition,//[20, 21, 50, 50, 25, 62, 72, 72, 72], // TODO: Add data to data
              pointHitRadius: 6,
              pointHoverRadius: 6,
              borderWidth: 1,

            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins = {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        };
        options.scales.y.display = false;
        options.scales.x.display = false;
        this.totalrecognitionLinechart = new Chart(totalrecognitionLinechart.getContext("2d"), {
          type: "line",
          data: lineChartData,
          options: options,
        });
      }
    },
    randervaluealignedLineChart() {
      var valuealignedLinechart = this.$refs.valuealignedLinechart
      let color=''
      if(parseInt(this.dataOverAll.comparevalue_aligned)>0){
          color='#1AC362'
      }else if(parseInt(this.dataOverAll.comparevalue_aligned)==0){
        color='#777777'
      }else{
        color='#F44336'
      }
      const point= []
      for(var i=0;i<this.dataOverAll.labels.length;i++){
        point.push(0)
      }
      if (valuealignedLinechart) {
        const lineChartData = {
          labels: this.dataOverAll.labels,//["","","","","","","","",""],
          datasets: [
            {
              backgroundColor: "#7E3FC700",
              borderColor: color,//"#1AC362",
              pointHoverBackgroundColor: color,//"#1AC362",
              pointBackgroundColor: color,//"#1AC362",
              pointRadius: point,//[0, 0, 0, 0, 0],
              lineTension: 0,
              data:  this.dataOverAll.chartvalue_aligned,//[20, 21, 50, 50, 25, 62, 66, 70, 72], // TODO: Add data to data
              pointHitRadius: 6,
              pointHoverRadius: 6,
              borderWidth: 1,
              // data: this.activeRecord.data, // [20, 21, 50, 80, 25, 41, 20, 4, 0, 0, 4 , 12], // TODO: Add data to data
            },
          ],
        };

        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins = {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        };
        options.scales.y.display = false;
        options.scales.x.display = false;
        this.valuealignedLinechart = new Chart(valuealignedLinechart.getContext("2d"), {
          type: "line",
          data: lineChartData,
          options: options,
        });
      }
    },
    randerpercentvalueLineChart() {
      var percentvalueLinechart = this.$refs.percentvalueLinechart;
      let color=''
      if(parseInt(this.dataOverAll.comparepercent_value_aligned)>0){
          color='#1AC362'
      }else if(parseInt(this.dataOverAll.comparepercent_value_aligned)==0){
        color='#777777'
      }else{
        color='#F44336'
      }
      const point= []
      for(var i=0;i<this.dataOverAll.labels.length;i++){
        point.push(0)
      }
      if (percentvalueLinechart) {
        const lineChartData = {
          labels: this.dataOverAll.labels,//["","","","","","","","",""],
          datasets: [
            {
              backgroundColor: "#7E3FC700",
              borderColor: color,//"#1AC362",
              pointHoverBackgroundColor: color,//"#1AC362",
              pointBackgroundColor: color,//"#1AC362",
              pointRadius:point,// [0, 0, 0, 0, 0],
              lineTension: 0,
              data:  this.dataOverAll.chartpercent_value_aligned,//[20, 21, 50, 50, 25, 62, 72, 72, 72], // TODO: Add data to data
              pointHitRadius: 6,
              pointHoverRadius: 6,
              borderWidth: 1,
              // data: this.activeRecord.data, // [20, 21, 50, 80, 25, 41, 20, 4, 0, 0, 4 , 12], // TODO: Add data to data
            },
          ],
        };
       
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins = {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        };
        options.scales.y.display = false;
        options.scales.x.display = false;
        this.percentvalueLinechart = new Chart(percentvalueLinechart.getContext("2d"), {
          type: "line",
          data: lineChartData,
          options: options,
        });
      }
    },
    randerparticipationLineChart() {
      var participationLinechart = this.$refs.participationLinechart;
      let color=''
      if(parseInt(this.dataOverAll.past_participation)>0){
          color='#1AC362'
      }else if(parseInt(this.dataOverAll.past_participation)==0){
        color='#777777'
      }else{
        color='#F44336'
      }
      const point= []
      for(var i=0;i<this.dataOverAll.labels.length;i++){
        point.push(0)
      }
      if (participationLinechart) {
        const lineChartData = {
          labels: this.dataOverAll.labels,//["","","","","","","","",""],
          datasets: [
            {
              backgroundColor: "#7E3FC700",
              borderColor: color,//"#F44336",
              pointHoverBackgroundColor: color,//"#F44336",
              pointBackgroundColor: color,//"#F44336",
              pointRadius: point,//[0, 0, 0, 0, 0],
              lineTension: 0,
              data:  this.dataOverAll.chartparticipation,//[20, 21, 50, 50, 25, 62, 72, 60, 55], // TODO: Add data to data
              pointHitRadius: 6,
              pointHoverRadius: 6,
              borderWidth: 1,
              // data: this.activeRecord.data, // [20, 21, 50, 80, 25, 41, 20, 4, 0, 0, 4 , 12], // TODO: Add data to data
            },
          ],
        };

        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins = {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        };
        options.scales.y.display = false;
        options.scales.x.display = false;
        this.participationLinechart = new Chart( participationLinechart.getContext("2d"), {
          type: "line",
          data: lineChartData,
          options: options,
        });
      }
    },
    sortChange({ column, prop, order }) {

      if (order) {
        this.$store.commit("activity/setActivity", []);
        this.$store.dispatch("activity/sortData", {column:prop,
          order:order,}
        );
      }
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.$store.dispatch("activity/currentChange", val);
    },
    checkDate(value) {
      if (value) {
        let time = value.date.split("-");
        const year = time[0];
        const month = Number(time[1]) - 1;
        let time2 = time[2].split(" ");
        const day = time2[0];
        let time3 = time2[1].split(":");
        const hour = time3[0];
        const minute = time3[1];
        const d = new Date();
        const c = new Date(year, month, day, hour, minute);
        if (d.getTime() < c.getTime()) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    sortBy(id) {
      this.isTableMonthOverride = true;
      this.selectedOpt = id.name;
      this.selectedOptValue = id.value;
      this.loadTableDataForSelectedMonth().then(() => {
        this.applyActiveTableFilters();
      });
    },

    async exportTableToCSV() {
      this.exportActivityStatus = true;
      this.dialogExport = false;
      await this.$store.dispatch("activity/getDataReport", {
        user: this.user,
        start: this.exportDate[0],
        end: this.exportDate[1],
        scopeKey: this.getResolvedScopeKey(),
        hashtag: this.checkedTalentType,
        core_value:this.checkedTalentType,
        classification:this.checkedArrClassificationCheck,
        reward:this.checkedArrRewardTypeCheck
      });
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "Activity";
      // /*Column headers*/
      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Recipient",
        "Recipient Email",
        "From",
        "Sender Email",
        "For",
        "Value 1",
        "Value 1 Rating",
        "Value 2",
        "Value 2 Rating",
        "Reward Amount",
        "Reward Type",
        "Date and Time",
      ];
      ws.getRow(4).values = header;
      /*Data*/
      _.forEach(this.reportActivity, (item, key) => {
        /* Value Check */
        let value1 = '';
        let value2 = '';
        let value1_rating = '';
        let value2_rating = '';
        if(item.hashtag && item.hashtag.length > 0){
          if(item.hashtag[0]){
            value1 = item.hashtag[0]
            if(item.core_value_ai && Object.keys(item.core_value_ai).length > 0){
              let propertyNames = Object.keys(item.core_value_ai)
              value1_rating = item.core_value_ai[propertyNames[0]].rating
            }else{
              value1_rating = '-'
            }
          }
          if(item.hashtag[1]){
            value2 = item.hashtag[1]
            if(item.core_value_ai && Object.keys(item.core_value_ai).length > 1){
              let propertyNames = Object.keys(item.core_value_ai)
              value2_rating = item.core_value_ai[propertyNames[1]].rating
            }else{
              value2_rating = '-'
            }
          }
        }
        /* End Value Check */
        let _tmp = [
          "",
          item.send_to,
          item.send_to_email,
          item.from,
          item.sender_email,
          item.reason.replace(/\n/g, " "),
          value1,
          value1_rating,
          value2,
          value2_rating,
          item.reward ? 1 : item.point,
          item.reward ? item.reward + " Medal" : item.unit,
          item.send_on,
        ];
        ws.addRow(_tmp);
      });

      ws.eachRow(function (row) {
        if (row.number == 4) {
          row.eachCell(function (cell) {
            ws.getCell(cell.address).font = {
              name: "Arial",
              size: 11,
              bold: true,
            };
          });
        }
      });

      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download =
            "Activity" + format(new Date(), "YYYY-MM-DD HH:mm:ss") + ".xlsx";
          document.body.appendChild(a);
          a.click();
        })
        .catch(function (error) {
          console.warn(error.message);
        });
      this.exportActivityStatus = false;
    },
    handleSelectAllValues() {
      if (this.checkedTalentType.length !== this.talentTypeOption.length) {
        let checked = [];
        for (const i in this.talentTypeOption) {
          checked.push(this.talentTypeOption[i].type);
        }
        this.checkedTalentType = checked;
      }
    },
    clearValueSelected() {
      this.checkedTalentType = this.arrDataCheck;
      this.$refs.dropdownValuesMenu.visible = false;
    },
    saveValueFiltered() {
      this.arrDataCheck = this.checkedTalentType;
      this.$refs.dropdownValuesMenu.visible = false;

      this.$store.commit("activity/setFilter", true);
      this.$store.commit("activity/setActivity", []);
      this.$store.dispatch("activity/getdatafilter", {core_value:this.checkedTalentType,classification:this.checkedArrClassificationCheck,reward:this.checkedArrRewardTypeCheck});
    },
    handleSelectAllRewardType() {
      if (this.checkedArrRewardTypeCheck.length !== this.rewardTypeOptions.length) {
        let checked = [];
        for (const i in this.rewardTypeOptions) {
          checked.push(this.rewardTypeOptions[i].type);
        }
        this.checkedArrRewardTypeCheck = checked;
      }
    },
    clearRewardTypeSelected() {
      this.checkedArrRewardTypeCheck = this.arrRewardTypeCheck;
      this.$refs.dropdownRewardTypeMenu.visible = false;
    },
    saveRewardTypeFiltered() {
      this.arrRewardTypeCheck = this.checkedArrRewardTypeCheck;
      this.$refs.dropdownRewardTypeMenu.visible = false;

      this.$store.commit("activity/setFilter", true);
      this.$store.commit("activity/setActivity", []);
      this.$store.dispatch("activity/getdatafilter", {core_value:this.checkedTalentType,classification:this.checkedArrClassificationCheck,reward:this.checkedArrRewardTypeCheck});
      // this.$store.dispatch("activity/getDataHashtag", this.checkedTalentType);
    },
    handleSelectAllClassification() {
      if (this.checkedArrClassificationCheck.length !== this.classificationOptions.length) {
        let checked = [];
        for (const i in this.classificationOptions) {
          checked.push(this.classificationOptions[i].type);
        }
        this.checkedArrClassificationCheck = checked;
      }
    },
    clearClassificationSelected() {
      this.checkedArrClassificationCheck = this.arrClassificationCheck;
      this.$refs.dropdownClassificationMenu.visible = false;
    },
    saveClassificationFiltered() {
      this.arrClassificationCheck = this.checkedArrClassificationCheck;
      this.$refs.dropdownClassificationMenu.visible = false;

      this.$store.commit("activity/setFilter", true);
      this.$store.commit("activity/setActivity", []);
      this.$store.dispatch("activity/getdatafilter", {core_value:this.checkedTalentType,classification:this.checkedArrClassificationCheck,reward:this.checkedArrRewardTypeCheck});
      // this.$store.dispatch("activity/getDataHashtag", this.checkedTalentType);
    },
    randerRecognitionChart() {
      var recognitionBarChart = this.$refs.recognitionBarChart;
      const trendBuckets = this.recognitionTrendBuckets;
      const barChartData = trendBuckets.map((bucket) => bucket.totalRecognition);
      const valuesAlignedData = trendBuckets.map((bucket) => bucket.valuesAligned);
      const participationData = trendBuckets.map((bucket) => bucket.participationRate);
      const tooltipLabels = trendBuckets.map((bucket) => bucket.tooltipLabel);
      const maxValue = Math.max(100, ...barChartData);

      if (recognitionBarChart && trendBuckets.length > 0) {
        this.loadingChartStatus = false;
        const data = {
          labels: tooltipLabels,
          datasets: [
            {
              data: participationData,
              type: "line",
              yAxisID: "lineChart",
              backgroundColor: "#35D07700",
              borderWidth: 2,
              borderColor: "#32C2D5",
              pointRadius: 0,
              pointHoverRadius: 0,
              pointHitRadius: 0,
              hover: false,
              position: "left",
              label: "",
              lineTension: 0,
              participation: participationData,
              valuesBased: valuesAlignedData,
              sumData: barChartData,
              datalabels: {
                display: false,
              },
              order: 2,
            },
            {
              data: valuesAlignedData,
              borderSkipped: false,
              label: "",
              backgroundColor: function(context) {
                var gradient = context.chart.ctx.createLinearGradient(0, 0, 0, 150);
                gradient.addColorStop(0, '#30135F'); 
                gradient.addColorStop(1, '#823CF0');
                return gradient;
              },
              participation: participationData,
              valuesBased: valuesAlignedData,
              sumData: barChartData,
              datalabels: {
                display: false,
              },
              order: 0,
            },
            {
              data: barChartData,
              borderSkipped: false,
              label: "",
              backgroundColor: "#BEBEBE",
              participation: participationData,
              valuesBased: valuesAlignedData,
              sumData: barChartData,
              datalabels: {
                color: "#919191",
                anchor: "end",
                align: "end",
                clamp: true,
                offset: 0,
              },
              order: 1,
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.layout = {
          padding: {
            top: 30,
            bottom: 0,
            left: 12,
            right: 64,
          },
        };

        options.plugins.datalabels = {
          formatter: function (value, context) {
            const index = context.dataIndex;
            if (index === context.dataset.data.length - 1) {
              return value 
            } else {
              return "";
            }
          },
        };
        options.datasets.bar = {
          categoryPercentage: 0.5,
          borderRadius: {
            topLeft: 20,
            topRight: 20,
            bottomLeft: 20,
            bottomRight: 20,
          },
        };
        options.scales = {
          y: {
            // beginAtZero: true,
            max: maxValue,
            min: 0,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              stepSize: maxValue,
            },
          },
          lineChart: {
            type: "linear",
            display: false,
            position: "right",
            max: 100,
            min: 0,
            ticks: {
              stepSize: 100,
              // callback: function (value) {
              //   return value + "%";
              // },
            },
            grid: {
              drawOnChartArea: false,
            },
          },
          x: {
            stacked: true,
            grid: {
              display: false,
              drawBorder: true,
            },
            ticks: {
              color: "#00000000",
            },
          },
        };
        const getOrCreateTooltip = (chart) => {
          let tooltipEl = chart.canvas.parentNode.querySelector("div");

          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.style.background = "#3B3B3B";
            tooltipEl.style.borderRadius = "12px";
            tooltipEl.style.color = "white";
            tooltipEl.style.opacity = 1;
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.transform = "translate(-50%, 0)";
            tooltipEl.style.transition = "all .1s ease";
          
            

            const table = document.createElement("table");
            table.style.margin = "0px";

            tooltipEl.appendChild(table);
            chart.canvas.parentNode.appendChild(tooltipEl);
          }
          return tooltipEl;
        };

        const addCommasInNumber = (value) => {
          let num, oneDigit, str;
          if (value === undefined || value === null) {
            return "0";
          } else if (typeof value === "number") {
            num = value.toFixed(2);
          } else {
            num = value;
          }

          str = num.toString().split(".");
          if (str[0].length >= 4) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
          }
          if (str[1]) {
                          oneDigit = str[1].split("");
              if (str[1] === "00") {
                str = str[0];
              } else if (oneDigit[1] === "0") {
              str[1] = oneDigit[0];
              str = str.join(".");
            } else {
              str = str.join(".");
            }
          } else {
            str = str[0];
          }
          return str;
        };

        const externalTooltipHandler = (context) => {
          const { chart, tooltip } = context;
          const tooltipEl = getOrCreateTooltip(chart);

          if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          if (tooltip.body) {
            const bodyLines = tooltip.body.map((b) => b.lines);
            const tableHead = document.createElement("thead");
            const tableBody = document.createElement("tbody");
            bodyLines.forEach((body, i) => {
              const dataPoints = tooltip.dataPoints[i];
              const span = `<div class="container-tooltip" style="z-index: 99; border-radius: 12px; padding: 8px;">
                  <div style="position: relative; width: 120px;">
                    <div style="font-size: 12px; font-weight: 700;">
                      ${dataPoints.label}
                    </div>
                    <div style="display: flex; align-items: center; font-size: 12px; font-weight: 700; margin-top: 6px;">
                      <div style="width: 14px; height: 2px; background-color: #32C2D5; margin-right: 6px;"></div>
                      <div>${Math.round(dataPoints.dataset.participation[dataPoints.dataIndex])}%</div>
                    </div>
                    <div style="display: flex; align-items: center; font-size: 12px; font-weight: 700; margin-top: 6px;">
                      <div style="width: 16px; height: 16px; border-radius: 50%; background-color: #BEBEBE; margin-right: 6px;"></div>
                      <div>${addCommasInNumber(
                  dataPoints.dataset.sumData[dataPoints.dataIndex]
                )}</div>
                    </div>
                    <div style="display: flex; align-items: center; font-size: 12px; font-weight: 700; margin-top: 6px;">
                      <div style="width: 16px; height: 16px; border-radius: 50%; background-color: #6C30CC; margin-right: 6px;"></div>
                      <div>${addCommasInNumber(
                  dataPoints.dataset.valuesBased[dataPoints.dataIndex]
                )} (${(dataPoints.dataset.sumData[dataPoints.dataIndex] > 0 ? ((dataPoints.dataset.valuesBased[dataPoints.dataIndex] / dataPoints.dataset.sumData[dataPoints.dataIndex]) * 100) : 0).toFixed(0)}%)</div>
                    </div>
                </div>`;
              tableBody.innerHTML = span;
            });

            const tableRoot = tooltipEl.querySelector("table");

            while (tableRoot.firstChild) {
              tableRoot.firstChild.remove();
            }

            tableRoot.appendChild(tableHead);
            tableRoot.appendChild(tableBody);
          }

          const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = positionX + tooltip.caretX + "px";
          tooltipEl.style.top = positionY + tooltip.caretY + -56 + "px";
          tooltipEl.style.font = tooltip.options.bodyFont.string;
          tooltipEl.style.padding =
            tooltip.options.padding + "px " + tooltip.options.padding + "px";
        };
        options.plugins.tooltip = {
          enabled: false,
          position: "nearest",
          mode: 'index',
          intersect: false,
          external: externalTooltipHandler,
        };
        options.interaction = {
          mode: 'index',
          intersect: false,
          axis: 'x',
          includeInvisible: false
        };
        options.hover = {
          mode: 'index',
          intersect: false,
          animationDuration: 0
        };
        options.responsive = true;
        options.maintainAspectRatio = false;
        this.myBarChart = new Chart(recognitionBarChart.getContext("2d"), {
          type: "bar",
          data: data,
          options: options,
          plugins: [ChartDataLabels],
        });
      }
    },
    async selectNewMonth(value) {
      if (!value || !value.heatmapKey) {
        return;
      }
      this.selectedMonth = value.rawLabel;
      this.isMonthZoomed = true;
      this.$store.dispatch("activity/changeRedarChart", {
        selectedMonth: value.heatmapKey,
        label: this.radarchart.label,
      });
      this.isTableMonthOverride = true;
      this.selectedOptValue = value.heatmapKey;
      this.selectedOpt = format(new Date(`${value.heatmapKey}-01`), "MMMM YYYY");
      await this.loadTableDataForSelectedMonth();
      this.applyActiveTableFilters();
    },
    resetHeatmapZoom() {
      this.selectedMonth = "";
      this.isMonthZoomed = false;
    },
    getMonthSortValue(month) {
      if (!month) return 0;
      const [monthName, year] = month.split(' ');
      const monthIndex = {
        'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6,
        'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12
      };
            return parseInt(year) * 100 + (monthIndex[monthName] || 0);
    },
    isCurrentMonth(monthKey) {
      if (!monthKey) return false;
      return monthKey === format(new Date(), 'YYYY-MM');
    },
    calculateProjectedValues(currentTotal, currentValues, month) {
      if (!month) return { projectedTotal: currentTotal, projectedValues: currentValues };
      
      // Only project if we have some data
      if (currentTotal === 0) {
        return { projectedTotal: currentTotal, projectedValues: currentValues };
      }
      
      // Use a more conservative projection approach
      // Instead of assuming a specific day progress, use historical average as baseline
      // and add a modest 10-20% increase to account for incomplete month
      const conservativeIncrease = 0.15; // 15% increase
      const projectedTotal = Math.round(currentTotal * (1 + conservativeIncrease));
      const projectedValues = Math.round(currentValues * (1 + conservativeIncrease));
      
      return { 
        projectedTotal,
        projectedValues
      };
    },
    getMonthNumber(monthName) {
      const monthIndex = {
        'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6,
        'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12
      };
      return monthIndex[monthName] || 1;
    },
    getTrendIcon(row, index) {
      if (index === 0) return 'el-icon-minus';
      const prevRow = this.chartTableData[index - 1];
      if (!prevRow) return 'el-icon-minus';
      
      const currentTotal = row.totalRecognition;
      const prevTotal = prevRow.totalRecognition;
      
      if (currentTotal > prevTotal) return 'el-icon-top';
      if (currentTotal < prevTotal) return 'el-icon-bottom';
      return 'el-icon-minus';
    },
    getTrendColor(row, index) {
      if (index === 0) return '#909399';
      const prevRow = this.chartTableData[index - 1];
      if (!prevRow) return '#909399';
      
      const currentTotal = row.totalRecognition;
      const prevTotal = prevRow.totalRecognition;
      
      if (currentTotal > prevTotal) return '#1AC362';
      if (currentTotal < prevTotal) return '#F44336';
      return '#909399';
    },
    getPercentageClass(percentage) {
      if (percentage >= 60) return 'percentage-high';
      if (percentage >= 40) return 'percentage-medium';
      return 'percentage-low';
    },
    exportTableData() {
      const csvContent = this.generateCSVContent();
      this.downloadCSV(csvContent, `recognition-trends-${format(new Date(), "YYYY-MM-DD")}.csv`);
    },
    generateCSVContent() {
      const headers = ['Period', 'Total Recognition', 'Values-Aligned', '% Values-Aligned', 'Participation Rate', 'Notes'];
      const rows = this.chartTableData.map(row => [
        row.month,
        row.isProjected ? `${row.originalTotal} → ${row.totalRecognition}*` : row.totalRecognition,
        row.isProjected ? `${row.originalValues} → ${row.valuesAligned}*` : row.valuesAligned,
        `${Math.round(row.percentValuesAligned)}%`,
        `${Math.round(row.participationRate)}%`,
        row.isProjected ? 'Projected values based on current month progress' : ''
      ]);
      
      return [headers, ...rows].map(row => row.join(',')).join('\n');
    },
    downloadCSV(content, filename) {
      const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    checkChampion(value) {
      if(value.champion_id){
        const _find=_.find(this.outboxall, function(o) { return o.id==value.champion_id });
        if(_find){
          return _find.from + " (+ " + value.from + ")"
        }else{
          return value.from
        }
      }else{
        return value.from
      }

    },
    checkPoint(value) {
      if(value.point){
        if(value.champion_users&&value.champion_users.length>0){
          let point = value.point
          for(const i in value.champion_users){
            point=point-value.champion_users[i].coin

          }
          return point
        }else{
          return value.point
        }}
      }
   
  },
};
</script>

<style scoped lang="scss">
.content-box {
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.activity-metrics-card {
  border-radius: 6px;
  padding: 20px 24px;
  background: #fff;
  box-shadow:
    0px 0.3px 0.9px rgba(0, 0, 0, 0.008),
    0px 0.8px 2.1px rgba(0, 0, 0, 0.012),
    0px 1.5px 4px rgba(0, 0, 0, 0.015),
    0px 2.7px 7.1px rgba(0, 0, 0, 0.018),
    0px 5px 13.4px rgba(0, 0, 0, 0.022),
    0px 12px 32px rgba(0, 0, 0, 0.03);
}

.activity-metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.activity-metric {
  display: flex;
  flex-direction: column;
}

.activity-metric-label {
  font-size: 12px;
  font-weight: 700;
  color: #4a4a4a;
  margin-bottom: 10px;
}

.activity-metric-value-row {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  transition: opacity 0.2s ease;
}

.activity-metric-value-row.metric-loading {
  opacity: 0.5;
}

.activity-metric-number {
  font-size: 24px;
  font-weight: 500;
  color: #000;
  line-height: 1;
}

.activity-metric-change {
  font-size: 11px;
  font-weight: 700;
  padding-bottom: 3px;
}

.activity-metric-sparkline {
  width: 52px;
  height: 32px;
  flex-shrink: 0;
}

.activity-table-shell {
  position: relative;
}

.activity-table-shell.is-loading {
  min-height: 220px;
}

.activity-table-shell.is-loading .el-table {
  opacity: 0.55;
  transition: opacity 0.2s ease;
}

.activity-table-overlay {
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 6px;
}

.activity-table-shell:not(.is-loading) .el-table {
  opacity: 1;
  transition: opacity 0.2s ease;
}

.btnActionDuplicate {
  color: #747474;
  font-size: 15px;
  font-weight: 700;
}

.el-table th>.cell {
  font-weight: 500;
}

.hide-button {
  transform: rotate(90deg);
  border-width: 0px;

  &:hover {
    color: #606266;
    border-color: transparent;
    background-color: transparent;
  }
}

.line-page {
  background-color: #e0e0e0;
  height: 1px;
}

.menuOptionPowerup {
  width: 200px;
  border-radius: 8px;
  height: 40px;
}

.txtOptionShowing {
  color: #000000;
  font-size: 14px;
  margin-left: 16px;
}

.override-reset-pill {
  padding: 8px 12px;
  border-radius: 16px;
  background: #eef4ff;
  color: #2f5ec4;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
}

.btn-export {
  font-size: 13px;
  font-weight: 700;
  padding: 12px 16px;
  border-radius: 8px;
}

.filter-text {
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  padding: 7px 16px 5px;
  background-color: #00bcd4;
  border-radius: 12px;
}

.dropdownHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding-left: 24px;
  padding-right: 16px;
  margin-bottom: 10px;
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.dropdownHeaderTextStyle {
  font-size: 13px;
  font-weight: 700;
}

.el-button--text.dropdownHeaderTextStyle {
  color: #32c2d5;
}

.el-button--text.dropdownHeaderTextStyle:hover {
  color: #249fb0;
}

.el-button--text.dropdownHeaderTextStyle:active {
  color: #32c2d5;
}

.tooltipStyle {
  max-width: 240px;
}

.dropdownFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 56px;
  padding-right: 16px;
  background: #f8f8f8;
  border-top: 1px solid #e8e8e8;

  .el-button--cancel {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
  }

  .el-button--cancel:hover,
  .el-button--cancel:focus {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 0.7;
  }

  .el-button--cancel:active {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 1;
  }

  .el-button--save {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
  }

  .el-button--save:hover,
  .el-button--save:focus {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 0.7;
  }

  .el-button--save:active {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 1;
  }
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: 24px;
  padding-bottom: 8px;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}
.heatmap {
      display: flex;
      flex-direction: column;
    }

.block {
      width: 42px;
      height: 24px;
      border: 1px solid #fff;
      background-color: #6c30cc;
      color: #fff;
      margin-bottom: 2px;
      text-align: center;
      font-size: 12px;


      


    }

.split-chart {
  display: grid;
  grid-template-columns: calc(750px - 16px) auto;
  margin: 12px 0 32px;
  background-color: rgba(0,0,0,0.03);
  padding: 24px 0 12px;
  border-radius: 24px;
  .radar-container {
    margin-left: 16px;
    // background: #ffffff 0% 0% no-repeat padding-box;
    // box-shadow: 0px 2px 4px #00000029;
    background: rgba(0,0,0,0.03);
    border-radius: 24px;
  }

  .recognition-container {
    
    // background-color: rgba(0,0,0,0.03);
    //  padding: 24px 0 12px;
     margin-left:24px ;
    // // background: #ffffff 0% 0% no-repeat padding-box;
    // // box-shadow: 0px 2px 4px #00000029;
    // border-radius: 24px;

    .recognition-title.line {
      width: 20px;
      height: 2px;
      background-color: #32C2D5;
    }

    .recognition-title.total {
      width: 20px;
      height: 16px;
      background-color: #bebebe;
      border-radius: 12px;
    }

    .recognition-title.paticipation {
      width: 20px;
      height: 16px;
      background-color: #6c30cc;
      border-radius: 12px;
    }
  }


}

.month-contariner {
  margin-top: 158px;
  z-index: 9;
  position: absolute;
  width: 91%;
}

.month-label {
  margin: 32px 0px 0 50px;
  user-select: none;
  text-transform: uppercase;

  span {
    cursor: pointer;
    padding: 4px 6px 2px;
    color: rgba(#000000,1);
    font-weight: 700;
    border-radius: 14px;
    transition: 0.2s;
    text-align: center;
  }

  span.select {
    color: #fff;
    background-color: #6c30cc;
  }
}

.activity-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.drop-down-container {
  height: 40px;
  border-radius: 8px;
  padding: 0 12px;
  background: #ffffff;
  border: 1px solid #e2e4ea;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  white-space: nowrap;
}

.drop-down-container:hover {
  background: #f6f7f9;
  border-color: #d4d7de;
}

.toolbar-icon-btn--end {
  margin-left: auto;
}

.values-text-container {
  width: 132px;
  flex-shrink: 0;
}

.value-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: help;
  width: 100%;
}

.value-label {
  height: 26px;
  margin-bottom: 2px;
  display: block;
  line-height: 26px;
  width: 100%;
}
.drop-down-container.active {
  background-color: rgba(108, 48, 204, 0.08);
  border-color: rgba(108, 48, 204, 0.25);
}

.drop-down-container.active .text-drop-down {
  color: #6c30cc;
}

.drop-down-container.active .text-drop-down .el-icon-arrow-down {
  color: #6c30cc;
}

.text-drop-down {
  color: #4a4a4a;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  letter-spacing: 0.01em;
}

.text-drop-down .el-icon-arrow-down {
  color: #9ca3af;
  font-size: 14px;
  transition: transform 0.2s ease, color 0.2s ease;
}

.drop-down-container:hover .text-drop-down .el-icon-arrow-down {
  color: #6b7280;
}

.drop-down-close {
  position: absolute;
  top: -12px;
  transform: rotate(45deg);
  width: 24px;
  height: 24px;
  margin-left: 4px;

  .x-btn {
    position: relative;
    width: 24px;
    height: 24px;
    cursor: pointer;

    &:before,
    &:after {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      content: "";
      background-color: #747474;
      transition: 0.3s;
    }

    &:before {
      width: 2px;
      height: 20px;
    }

    &:after {
      width: 20px;
      height: 2px;
    }

    &:hover {

      &:before,
      &:after {
        background-color: #333;
      }
    }
  }
}

.toolbar-icon-btn {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e2e4ea;
  color: #4a4a4a;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.toolbar-icon-btn:hover {
  background: #f6f7f9;
  border-color: #d4d7de;
  color: #6c30cc;
}

.icon-export {
  cursor: pointer;
  color: #666;
  transition: all 0.2s ease;

  &:hover {
    color: #333;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.search-input-activity {
  width: 220px !important;

  ::v-deep .el-input__inner {
    height: 40px;
    border-radius: 8px;
    border-color: #e2e4ea;
    background: #f6f7f9;
    transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;

    &:focus {
      border-color: #6c30cc;
      background: #ffffff;
      box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.12);
    }
  }
}

.menu-list-item {
  color: #4a4a4a;
}
.el-menu--horizontal .el-menu .el-menu-item:hover .menu-list-item {
  color: white;
  font-weight: 600;
}

.heatmap-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.reset-zoom-btn {
  font-size: 11px;
  color: #6c30cc;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
  transition: all 0.2s;
  
  &:hover {
    background-color: rgba(108, 48, 204, 0.1);
  }
}

.zoom-indicator {
  font-size: 10px;
  color: #909399;
  font-weight: 400;
  margin-left: 8px;
}
</style>

<style lang="scss">
.dropdownItem-tabActivity {
  overflow-y: auto;
  max-height: 228px;
  margin-right: 12px;

  .el-checkbox__input+.el-checkbox__label {
    font-weight: 700;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    font-weight: 700;
    color: #292929;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #00bcd4;
    border-color: #00bcd4;
  }
}

#tabActivity .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
  width: 200px;
  margin-right: 46px;
}

#menuActivityPeriod > li > div {
  border-radius: 4px;
  width: 200px;
  height: 36px;
  line-height: 40px;
}

#menuActivityPeriod > li {
  margin-top: 0px;
  width: 200px;
  height: 36px;
}

#menuActivityPeriod > li > div > i {
  margin-right: 9%;
  float: right;
  margin-top: 6%;
}

#tabActivity .el-menu--horizontal>.el-menu-item {
  color: rgba(0, 0, 0, 0.62);
  font-size: 14px;
  font-weight: 400;
  height: 40px;
}

#tabActivity .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus .el-menu-item:hover {
  background-color: transparent;
  color: #6c30cc;
}

#tabActivity .el-menu--horizontal>.el-menu-item.is-active {
  background-color: transparent;
  border-bottom: 2px solid #6c30cc;
  color: #6c30cc;
  font-weight: 700;
}

#menuSortMonth>li>div {
  border-radius: 4px;
  width: 240px;
  height: 36px;
  line-height: 40px;
}

#menuSortMonth>li {
  margin-top: 0px;
  width: 240px;
  height: 36px;
}

#menuSortMonth>li>div>i {
  margin-right: 9%;
  float: right;
  margin-top: 6%;
}

.chart-table-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: all 0.2s ease;
  margin-top: 20px;
}

.chart-table-icon:hover {
  background-color: #e0e0e0;
  color: #333;
}

.chart-table-icon i {
  font-size: 16px;
}

.number-cell {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.trend-indicator i {
  font-size: 14px;
  font-weight: bold;
}

.values-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.2;
}

.percentage-label {
  font-size: 12px;
  color: #909399;
  font-weight: 400;
  margin-top: 2px;
}

.percentage-high {
  color: #1AC362;
}

.percentage-medium {
  color: #E6A23C;
}

.percentage-low {
  color: #F44336;
}

.chart-table .el-table th {
  font-weight: 600;
  color: #303133;
  background-color: #fafafa;
}

.chart-table .el-table td {
  padding: 14px 12px;
}

.chart-table .el-table th {
  padding: 16px 12px;
}

.recognition-value {
  display: flex;
  align-items: center;
  gap: 4px;
}

.values-main {
  display: flex;
  align-items: center;
  gap: 4px;
}

.projected-indicator {
  color: #6c30cc;
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  cursor: help;
}

.dual-value {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.2;
  gap: 2px;
}
</style>
